import { render } from "./FreitextModal.vue?vue&type=template&id=d106f5c4"
import script from "./FreitextModal.vue?vue&type=script&lang=js"
export * from "./FreitextModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__